<template>
    <div class="pb-5">
        <data-table ref="questionGroups"
                    :api-route="backendApiRoute"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key">
        </data-table>
    </div>
</template>

<script>
import DataTable from "@/components/Table/DataTable.vue";
import {mapGetters} from "vuex";
import api from "@/api";
import actions from "@/components/Table/actions";
import { QuestionGroup } from "@/pages/AppPages/Catalogs/FAQ/questionGroup";

export default {
    name: "QuestionGroupList",
    components: {DataTable},
    computed: {
        ...mapGetters(['ability']),
        backendApiRoute() { return api.questionGroups.default.list() },
    },
    data() {
        return {
            table: {
                name: 'question-groups-table',
                apiViewSet: api.questionGroups.default,
                key: 'question-groups-table',
                search: true,
                columns: [
                    {
                        name: 'name',
                        title:  'Название',
                        alwaysVisible: true,
                        to: {
                            idColumn: 'id',
                            routeName: 'questionGroupDetail',
                            prependWithN: false
                        }
                    },
                    { name: 'list_order', 'title': 'Порядок'},
                ],
                orderings: [
                    'name',
                    'list_order',
                ],
                actions: [],
                rowActions: [],
                filters: []
            }
        }
    },

    mounted() {
        this.table.actions.push(
            actions.create(() => {
                    this.$router.push({name: 'questionGroupCreate'})
                }, this.ability.can('create', 'QuestionGroup')
            )
        );

        if (this.ability.can('destroy', 'QuestionGroup')) {
            this.table.rowActions.push(
                new actions.objectDelete(QuestionGroup))
        }

    }

}
</script>

<style scoped>

</style>